import { Component } from '@angular/core';

@Component({
  selector: 'app-sibling-detail',
  imports: [],
  templateUrl: './sibling-detail.component.html',
  styleUrl: './sibling-detail.component.css'
})
export class SiblingDetailComponent {

}
